<template>
    <div v-if="item && Object.keys(item).length > 0" class="text-muted">
        <vue-json-pretty :data="item" :deep="3" showLength />
    </div>
</template>

<script>
    import VueJsonPretty from 'vue-json-pretty'
    import 'vue-json-pretty/lib/styles.css'

    export default {
        name: 'RawOutput',
        props: {
            item: {
                type: [Array, Object],
                required: true,
            },
        },
        components: { VueJsonPretty },
    }
</script>
